import React from 'react';
import styled from '@emotion/styled';
import { WidgetHeader, WidgetHeaderProps } from './WidgetHeader';

const Frame = styled.div({
    backgroundColor: '#fff',
    height: 'fit-content',
});

const Content = styled.div({
    backgroundColor: 'white',
    padding: '4px',
});

export type WidgetProps = React.PropsWithChildren<{
} & WidgetHeaderProps>;

export const Widget = (props: WidgetProps) => {
    return (
        <Frame>
            <WidgetHeader {...props} />
            <Content>
                {props.children}
            </Content>
        </Frame>
    );
};
